module.exports = __webpack_public_path__ + "static/media/matthew_fun.f0b81f21.png";